import axios from 'axios';
import { API_URL_NEW } from '../lib/endpoints';

const contactSalesApi = {

    post: (payload) => {
        const url = `${API_URL_NEW}/sales-contact`;

        return new Promise((resolve, reject) => {
            axios.post(url, payload).then(response => {
                if (response.data.status === 201) {
                    resolve(response.data.data)
                } else {
                    reject(response);
                }
            }).catch((err) => reject(err));
        });
    },

    
}

export default contactSalesApi;